module.exports = __webpack_public_path__ + "img/katamyahospital.b68477df.jpg";